import { useState } from "react";
import { verifyChatPin, type ChatLockRecord } from "@veto/domain";
import { ModalShell } from "./ModalShell";

export function ChatLockGate({
  lock,
  title,
  onUnlock,
  onCancel,
}: {
  lock: ChatLockRecord;
  title: string;
  onUnlock: () => void;
  onCancel: () => void;
}) {
  const [pin, setPin] = useState("");
  const [err, setErr] = useState<string | null>(null);
  return (
    <ModalShell
      title="Chat locked"
      ariaLabel="Chat locked"
      onClose={onCancel}
      size="sm"
      className="add-contact-card"
      footer={
        <div className="actions-row">
          <button type="button" className="btn secondary" onClick={onCancel}>
            Back
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => {
              void verifyChatPin(lock, pin).then((ok) => {
                if (ok) onUnlock();
                else setErr("Incorrect PIN");
              });
            }}
          >
            Unlock
          </button>
        </div>
      }
    >
      <div className="stack">
        <p className="muted">
          Enter the PIN for <strong>{title}</strong>. This lock is local-only — not end-to-end
          encryption.
        </p>
        <div className="field">
          <label htmlFor="chatLockPin">PIN</label>
          <input
            id="chatLockPin"
            type="password"
            inputMode="numeric"
            autoComplete="off"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
          />
        </div>
        {err && (
          <p className="text-danger" role="alert">
            {err}
          </p>
        )}
      </div>
    </ModalShell>
  );
}
